import React from 'react'
import { setAppValue } from 'e-submission/apps/actions'

export const CreateTitle = (_message) => {
  return (
    <div style={stylesRow.RowInline}>
      <label style={stylesRow.textSubTitle}>{_message}</label>
    </div>
  )
}

export const CreateImageSubTitle = (_image) => {
  return (
    <div style={stylesRow.RowInlineImage}>
      <img src={_image} style={stylesRow.ImageTitle} />
    </div>
  )
}

export const CreateImageBase64 = (_base64) => {
  return (
    <div style={stylesRow.RowInlineImage}>
      <img src={`data:image/jpeg;base64,${_base64}`} style={stylesRow.ImageTitle} />
    </div>
  )
}

export const CreateDetails = (_message) => {
  return (
    <div style={stylesRow.RowDetailsInline}>
      <label style={stylesRow.textDetails}>{_message}</label>
    </div>
  )
}

export const CreateDetailsWithTAG = (_message) => {
  return (
    <div style={stylesRow.RowDetailsInline}>
      <li>
        <label style={stylesRow.textDetails}>{_message}</label>
      </li>
    </div>
  )
}

export const CreateICONWithDetails = (Icon, _message) => {
  return (
    <div style={stylesRow.RowInlineWithDetails}>
      <div style={stylesRow.iconLeft}>{Icon}</div>
      <div>
        <label style={stylesRow.textDetails}>{_message}</label>
      </div>
    </div>
  )
}

export const DataByResultCode = (code) => {
  const DataDetact = [
    {
      code: 200,
      title: 'ผลการสแกนหน้าบัญชีธนาคาร',
      message: 'Done',
      sub_message: null,
      Done: () => {},
      Cancel: null,
    },
    {
      code: 201,
      title: 'ผลการสแกนหน้าบัญชีธนาคาร',
      message: 'ข้อมูลบัญชีธนาคารไม่ตรงกับที่ท่านระบุ โปรดยืนยันหากท้านต้องการใช้ข้อมูลนี้',
      sub_message: {
        bankname: 'ธนาคารกรุงศรีอยุธยา',
        name: 'นางสาว สุธิดา รัตตสัมพันธ์',
        banknumber: '0041111111',
      },
      Done: () => {},
      Cancel: () => {},
    },
    {
      code: 400,
      title: 'ผลการสแกนหน้าบัญชีธนาคาร',
      message: 'ธนาคารของท่านไม่สามารถทำการสมัครได้ กรุณาเปลี่ยนบัญชีธนาคาร',
      sub_message: null,
      Done: () => {},
      Cancel: null,
    },
    {
      code: 403,
      title: 'ผลการสแกนหน้าบัญชีธนาคาร',
      message: 'ระบบไม่สามารถสแกนหน้าบัญชีธนาคารได้ กรุณาทำรายการใหม่อีกครั้ง',
      sub_message: null,
      Done: () => {},
      Cancel: null,
    },
    {
      code: 200,
      title: 'ผลการสแกนหน้าบัญชีธนาคาร',
      message: 'ระบบไม่สามารถสแกนหน้าบัญชีธนาคารได้ กรุณากรอกข้อมูลบัญชีธนาคารด้วยตนเอง',
      sub_message: null,
      Done: () => {},
      Cancel: null,
    },
    {
      code: 500,
      title: 'ขณะนี้ระบบขัดข้อง',
      message: 'ระบบไม่สามารถทำรายการได้ กรุณากรอกข้อมูลบัญชีธนาคารด้วยตนเอง',
      sub_message: null,
      Done: () => {},
      Cancel: null,
    },
  ]

  return DataDetact.find((_data) => _data.code == code)
}

export const onSetValueOCR = (dispatch, apptype, bank, data) => {
  try {
    if (apptype != 'ATP') {
      const getBank = bank
        .map(({ text, code, monthlyCollect }) => ({
          text,
          monthlyCollect,
          value: code,
        }))
        .find((res) => res.text == data.bankNameTH)
      if (getBank) {
        dispatch(setAppValue(apptype + '.bank', getBank))
      }
    }
    dispatch(
      setAppValue(apptype == 'ATP' ? apptype + '.bankBookNumber' : apptype + '.accountNumber', data.accountNumber)
    )
    dispatch(setAppValue(apptype == 'ATP' ? apptype + '.bankBookName' : apptype + '.accountName', data.accountName))
  } catch (error) {}
}

export const base64ToBlob = (base64, mimeType) => {
  const byteString = atob(base64.split(',')[1]) // แปลง Base64 เป็นข้อมูลไบนารี
  const ab = new ArrayBuffer(byteString.length)
  const ia = new Uint8Array(ab)

  for (let i = 0; i < byteString.length; i++) {
    ia[i] = byteString.charCodeAt(i)
  }

  return new Blob([ab], { type: mimeType })
}

// ฟังก์ชันเพื่อแปลง Blob เป็น File
export const base64ToFile = (base64, fileName, mimeType) => {
  const blob = base64ToBlob(base64, mimeType)
  return new File([blob], fileName, { type: mimeType })
}

const stylesRow = {
  RowInline: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    width: '100%',
  },
  RowInlineImage: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    width: '100%',
    height: '100%',
  },
  RowInlineWithDetails: {
    display: 'flex',
    justifyContent: 'left',
    width: '100%',
    paddingLeft: '5%',
    marginTop: '3%',
  },
  iconLeft: {
    marginRight: '3%',
  },
  textSubTitle: {
    fontSize: 18,
    fontWeight: 'bold',
    color: '#2425aa',
  },
  ImageTitle: {
    width: 300,
    height: 200,
  },
  RowDetailsInline: {
    width: '100%',
    padding: '5%',
  },
  textDetails: {
    fontSize: 18,
    color: '#2425aa',
  },
}
